/**
 * Lifecycle of an `InvoiceRun` (practice-wide batch invoice run / Rechnungslauf)
 * aggregate. Structural twin of `DunningRunStatus`.
 *
 * - `PENDING` — created with items, awaiting worker pickup.
 * - `IN_PROGRESS` — worker has begun iterating items.
 * - `COMPLETED` — worker finished. Per-item outcomes may include SUCCESS,
 *   SKIPPED, and FAILED; partial item failures do NOT promote the aggregate
 *   to FAILED.
 * - `CANCELED` — user-initiated abort while still PENDING or IN_PROGRESS.
 * - `FAILED` — reserved for the sweeper-only catastrophic path (stuck
 *   IN_PROGRESS runs older than the orphan threshold). User-facing commands
 *   cannot transition the aggregate to this state.
 */
export var InvoiceRunStatus;
(function (InvoiceRunStatus) {
    InvoiceRunStatus["PENDING"] = "pending";
    InvoiceRunStatus["IN_PROGRESS"] = "in_progress";
    InvoiceRunStatus["COMPLETED"] = "completed";
    InvoiceRunStatus["CANCELED"] = "canceled";
    InvoiceRunStatus["FAILED"] = "failed";
})(InvoiceRunStatus || (InvoiceRunStatus = {}));
//# sourceMappingURL=invoice-run-status.enum.js.map